import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the view for managing product tables.
 * @extends JetView
 */
export default class tableProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the data table
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('ProductsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'TypeDevice', // Column ID
                                    header: _('Dispositivo'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        {
                                            id: '1',
                                            value: "<span class='icon-phone'></span>",
                                        },
                                        {
                                            id: '2',
                                            value: "<span class='icon-display'></span>",
                                        },
                                        {
                                            id: '3',
                                            value: "<span class='icon-phone'></span><span class='icon-display'></span>",
                                        },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Image', // Column ID
                                    header: _('Imagen'), // Column header with localization
                                    width: 570, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Image2', // Column ID
                                    header: _('Imagen cuadrada'), // Column header with localization
                                    width: 570, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ProviderId', // Column ID
                                    header: _('Proveedor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CategoryName', // Column ID
                                    header: _('Categoría'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SubProviderId', // Column ID
                                    header: _('SubProveedor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsVerified', // Column ID
                                    header: _('Verificado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('ID Externo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId2', // Column ID
                                    header: _('ID Externo 2'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Visible', // Column ID
                                    header: _('Visible'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Producto Id'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('editProduct:button', [
                                        item, // Pass the item to the event
                                    ]);
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable'); // Reference to the data table
        var url = devConfig.geturlApi() + 'Products/GetProducts'; // API URL for fetching products
        var filter = ''; // Filter string for data fetching
        let tagsList = []; // List to hold tags

        // Event listener for editing a product
        this.on(this.app, 'editProduct:button', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories', // API URL for fetching categories
                    { global: true }, // Request payload
                    {
                        error: function () {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text) {
                            var resp = JSON.parse(text); // Parse the response
                            let tagsListExclude = []; // List for excluded tags
                            let tagsListInclude = ''; // List for included tags
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id; // Map ID
                                resp.data[i].value = resp.data[i].Description; // Map description
                            }
                            webix
                                .ui({
                                    view: 'window', // Create a window for editing
                                    id: 'editwinProducts', // Window ID
                                    width: screen.width < 500 ? 650 : 650, // Window width
                                    height: screen.width < 500 ? 630 : 700, // Window height
                                    fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                                    head: {
                                        view: 'toolbar', // Toolbar for window header
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Editar Producto'), // Label for editing product
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close the window
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the window
                                    modal: true, // Modal window
                                    body: {
                                        view: 'form', // Form for editing product details
                                        id: 'editform', // Form ID
                                        scroll: 'y', // Enable vertical scrolling
                                        elements: [
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Product ID
                                                        labelPosition: 'top',
                                                        label: _('Producto Id'), // Label for Product ID
                                                        name: 'Id', // Input name
                                                        readonly: true, // Read-only field
                                                    },
                                                    {
                                                        view: 'text', // Text input for Name
                                                        labelPosition: 'top',
                                                        label: _('Nombre'), // Label for Name
                                                        name: 'Name', // Input name
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Image URL
                                                        labelPosition: 'top',
                                                        label: _('Imagen URL'), // Label for Image URL
                                                        name: 'Image', // Input name
                                                    },
                                                    {
                                                        view: 'text', // Text input for Provider ID
                                                        labelPosition: 'top',
                                                        label: _('ID Provedor'), // Label for Provider ID
                                                        name: 'ProviderId', // Input name
                                                        readonly: true, // Read-only field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Status
                                                        labelPosition: 'top',
                                                        label: _('Estado'), // Label for Status
                                                        name: 'IsActivate', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Verificado'), // Label for Verified
                                                        name: 'IsVerified', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for External ID
                                                        labelPosition: 'top',
                                                        label: _('ID Externo'), // Label for External ID
                                                        name: 'ExternalId', // Input name
                                                        readonly: false, // Editable field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Visibility
                                                        labelPosition: 'top',
                                                        label: _('Visible'), // Label for Visibility
                                                        name: 'Visible', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for External ID 2
                                                        labelPosition: 'top',
                                                        label: _(
                                                            'ID Externo 2', // Label for External ID 2
                                                        ),
                                                        name: 'ExternalId2', // Input name
                                                        required: false, // Not required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Mobile status
                                                        labelPosition: 'top',
                                                        label: _('Mobile'), // Label for Mobile
                                                        name: 'Mobile', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Desktop status
                                                        labelPosition: 'top',
                                                        label: _('Escritorio'), // Label for Desktop
                                                        name: 'Desktop', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Theoretical RTP
                                                        labelPosition: 'top',
                                                        label: _('RTP teórico'), // Label for Theoretical RTP
                                                        name: 'TheoreticalRTP', // Input name
                                                    },
                                                    {
                                                        view: 'richselect', // Rich select for Category
                                                        name: 'Category', // Input name
                                                        localId: 'categorie:combo', // Local ID for the category combo
                                                        label: "<span class='icon-category'></span>" + _('Categorías'), // Label for Category
                                                        labelPosition: 'top',
                                                        placeholder: _(
                                                            'Click para seleccionar ', // Placeholder text
                                                        ),
                                                        options: resp.data, // Options for the category
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'datatable', // Data table for Tags
                                                id: 'TagsAdds', // Table ID
                                                name: 'TagsAdds', // Table name
                                                height: 300, // Table height
                                                columns: [
                                                    {
                                                        id: 'ch1', // Column ID for checkbox
                                                        header: [
                                                            {
                                                                content: 'masterCheckbox', // Master checkbox header
                                                            },
                                                        ],
                                                        checkValue: 'on', // Value when checked
                                                        uncheckValue: 'off', // Value when unchecked
                                                        template: '{common.checkbox()}', // Checkbox template
                                                        width: 40, // Column width
                                                    },
                                                    {
                                                        id: 'title', // Column ID for title
                                                        header: [
                                                            {
                                                                text: 'Etiqueta', // Header for Tags
                                                            },
                                                            {
                                                                content: 'textFilter', // Filter content
                                                            },
                                                        ],
                                                        fillspace: true, // Fill space
                                                        sort: 'string', // Sorting type
                                                        css: {
                                                            'text-align': 'left', // Text alignment
                                                        },
                                                    },
                                                ],
                                                scrollX: false, // Disable horizontal scrolling
                                                navigation: true, // Enable navigation
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'uploader', // Uploader for Image URL
                                                        upload: devConfig.geturlApi() + 'Product/UpdateProductDetails', // Upload URL
                                                        id: 'ImageURL', // Uploader ID
                                                        name: 'ImageURL', // Uploader name
                                                        value: _(
                                                            'Agregar imagen', // Button text
                                                        ),
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            userid: 123, // User ID for form data
                                                            document: 'attachment', // Document type
                                                        },
                                                    },
                                                    {
                                                        view: 'uploader', // Uploader for Image2 URL
                                                        upload: devConfig.geturlApi() + 'Product/UpdateProductDetails2', // Upload URL
                                                        id: 'ImageURL2', // Uploader ID
                                                        name: 'ImageURL2', // Uploader name
                                                        value: _(
                                                            'Agregar imagen cuadrada', // Button text
                                                        ),
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            userid: 123, // User ID for form data
                                                            document: 'attachment', // Document type
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Note
                                                        labelPosition: 'top',
                                                        label: _('Explicación'), // Label for Note
                                                        name: 'Note', // Input name
                                                        labelWidth: 160, // Label width
                                                        attributes: {
                                                            type: 'text', // Input type
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: _('Cancelar'), // Button text
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Close the window
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form', // Button type
                                                        value: _('Guardar'), // Button text
                                                        click: function ($e) {
                                                            // Click event for save button
                                                            if (
                                                                Object.keys($$('ImageURL').files.data.pull).length > 0
                                                            ) {
                                                                var values = $$('editform').getValues(); // Get form values
                                                                $$('ImageURL').config.formData.Id = values.Id; // Set ID in form data
                                                                $$('ImageURL').config.formData.IsActivate =
                                                                    values.IsActivate; // Set activation status
                                                                $$('ImageURL').config.formData.IsVerified =
                                                                    values.IsVerified; // Set verification status
                                                                $$('ImageURL').config.formData.Visible = values.Visible; // Set visibility
                                                                $$('ImageURL').config.formData.Mobile = values.Mobile; // Set mobile status
                                                                $$('ImageURL').config.formData.Desktop = values.Desktop; // Set desktop status
                                                                $$('ImageURL').send(function (response) {
                                                                    webix.message(
                                                                        'Producto Editado', // Success message
                                                                    );
                                                                });
                                                                grid.clearAll(); // Clear the grid
                                                                grid.load(
                                                                    url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter, // Reload grid data
                                                                );
                                                                this.getTopParentView().hide(); // Close the window
                                                            } else {
                                                                if (
                                                                    Object.keys($$('ImageURL2').files.data.pull)
                                                                        .length > 0
                                                                ) {
                                                                    var values = $$('editform').getValues(); // Get form values
                                                                    $$('ImageURL2').config.formData.Id = values.Id; // Set ID in form data
                                                                    $$('ImageURL2').config.formData.IsActivate =
                                                                        values.IsActivate; // Set activation status
                                                                    $$('ImageURL2').config.formData.IsVerified =
                                                                        values.IsVerified; // Set verification status
                                                                    $$('ImageURL2').config.formData.Visible =
                                                                        values.Visible; // Set visibility
                                                                    $$('ImageURL2').config.formData.Mobile =
                                                                        values.Mobile; // Set mobile status
                                                                    $$('ImageURL2').config.formData.Desktop =
                                                                        values.Desktop; // Set desktop status
                                                                    $$('ImageURL2').send(function (response) {
                                                                        webix.message(
                                                                            'Producto Editado', // Success message
                                                                        );
                                                                    });
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                    );
                                                                    this.getTopParentView().hide(); // Close the window
                                                                } else {
                                                                    let values = $$('editform').getValues(); // Get form values
                                                                    let tagsValue = $$('TagsAdds').serialize(); // Serialize tags
                                                                    let newTagsListExclude = tagsValue.filter(
                                                                        (item) => item.ch1 === 'off', // Filter excluded tags
                                                                    );
                                                                    newTagsListExclude = newTagsListExclude.map(
                                                                        (item) => item.id, // Map excluded tag IDs
                                                                    );
                                                                    let newTagsListInclude = tagsValue.filter(
                                                                        (item) => item.ch1 === 'on', // Filter included tags
                                                                    );
                                                                    newTagsListInclude = newTagsListInclude.map(
                                                                        (item) => item.id, // Map included tag IDs
                                                                    );
                                                                    newTagsListInclude = newTagsListInclude.filter(
                                                                        (item) =>
                                                                            !tagsListInclude.includes(
                                                                                item, // Exclude already included tags
                                                                            ),
                                                                    );
                                                                    let valueTags = {
                                                                        ProductId: item.Id, // Product ID
                                                                        ExcludedTagList: newTagsListExclude.toString(), // Excluded tags
                                                                        IncludedTagList: newTagsListInclude.toString(), // Included tags
                                                                    };
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type for AJAX request
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Product/UpdateProductDetails', // API URL for updating product details
                                                                            values, // Request payload
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message on failure
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Producto Editado', // Success message
                                                                                    );
                                                                                },
                                                                            },
                                                                        );
                                                                    if (
                                                                        newTagsListExclude.length > 0 ||
                                                                        newTagsListInclude.length > 0
                                                                    ) {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type for AJAX request
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'Tag/saveGroupTags2', // API URL for saving tags
                                                                                valueTags, // Request payload
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message on failure
                                                                                        );
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Etiquetas Guardadas', // Success message
                                                                                        );
                                                                                    },
                                                                                },
                                                                            );
                                                                    }
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                    );
                                                                    this.getTopParentView().hide(); // Close the window
                                                                }
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                })
                                .show(); // Show the edit window
                            webix.ajax().get(
                                devConfig.geturlApi() + 'Tag/GetGroupTagsProducts', // API URL for fetching product tags
                                { Id: item.Id }, // Request payload
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var data2 = JSON.parse(text); // Parse the response
                                        if (!data2.HasError) {
                                            tagsListExclude = data2.Data.ExcludedTagList.map((item) => {
                                                return {
                                                    id: item.id, // Map excluded tag ID
                                                    title: item.value, // Map excluded tag title
                                                };
                                            });
                                            tagsListInclude = data2.Data.IncludedTagList; // Get included tags
                                            tagsListExclude = tagsListExclude.map((item) => {
                                                if (
                                                    tagsListInclude.includes(
                                                        item.id, // Check if included
                                                    )
                                                ) {
                                                    item.ch1 = 'on'; // Mark as included
                                                }
                                                return item; // Return modified item
                                            });
                                            $$('TagsAdds').parse(
                                                tagsListExclude, // Parse excluded tags into the table
                                            );
                                        } else {
                                            webix.message('Error! '); // Error message on failure
                                        }
                                    },
                                },
                            );
                            $$('editform').setValues(item); // Set form values to the selected item
                        },
                    },
                );
        });

        // Event listener for adding a product
        this.on(this.app, 'addProduct:button', (filter) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories', // API URL for fetching categories
                    { global: true }, // Request payload
                    {
                        error: function () {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text) {
                            var resp = JSON.parse(text); // Parse the response
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id; // Map ID
                                resp.data[i].value = resp.data[i].Description; // Map description
                            }
                            webix
                                .ui({
                                    view: 'window', // Create a window for adding a product
                                    id: 'AddProducts', // Window ID
                                    width: screen.width < 500 ? 650 : 660, // Window width
                                    height: screen.width < 500 ? 520 : 800, // Window height
                                    fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                                    head: {
                                        view: 'toolbar', // Toolbar for window header
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Añadir Producto'), // Label for adding product
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close the window
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the window
                                    modal: true, // Modal window
                                    body: {
                                        view: 'form', // Form for adding product details
                                        id: 'addform', // Form ID
                                        scroll: 'y', // Enable vertical scrolling
                                        elements: [
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Name
                                                        labelPosition: 'top',
                                                        label: _('Nombre'), // Label for Name
                                                        name: 'Name', // Input name
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Provider
                                                        labelPosition: 'top',
                                                        label: _('Proveedor'), // Label for Provider
                                                        name: 'ProviderId', // Input name
                                                        options: {
                                                            body: {
                                                                dataFeed: function (text) {
                                                                    var vthis = this; // Reference to the current context
                                                                    if (text.length > 2) {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type for AJAX request
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'es/Select/SubProvidersCasinoSelect', // API URL for fetching subproviders
                                                                                '{"Filter":"' + text + '"}', // Request payload
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message on failure
                                                                                        );
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        var resp = JSON.parse(
                                                                                            text, // Parse the response
                                                                                        );
                                                                                        if (!resp.HasError) {
                                                                                            vthis.parse(
                                                                                                resp.Data, // Parse the data into the combo
                                                                                            );
                                                                                        }
                                                                                    },
                                                                                },
                                                                            );
                                                                    }
                                                                },
                                                            },
                                                        },
                                                        required: true, // Required field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Status
                                                        labelPosition: 'top',
                                                        label: _('Estado'), // Label for Status
                                                        name: 'IsActivate', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Visibility
                                                        labelPosition: 'top',
                                                        label: _('Visible'), // Label for Visibility
                                                        name: 'Visible', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for External ID
                                                        labelPosition: 'top',
                                                        label: _('ID Externo'), // Label for External ID
                                                        name: 'ExternalId', // Input name
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'text', // Text input for External ID 2
                                                        labelPosition: 'top',
                                                        label: _(
                                                            'ID Externo 2', // Label for External ID 2
                                                        ),
                                                        name: 'ExternalId2', // Input name
                                                        required: false, // Not required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Mobile status
                                                        labelPosition: 'top',
                                                        label: _('Movíl'), // Label for Mobile
                                                        name: 'Mobile', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Desktop status
                                                        labelPosition: 'top',
                                                        label: _('Escritorio'), // Label for Desktop
                                                        name: 'Desktop', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Theoretical RTP
                                                        labelPosition: 'top',
                                                        label: _('RTP teórico'), // Label for Theoretical RTP
                                                        name: 'TheoreticalRTP', // Input name
                                                        required: false, // Not required
                                                    },
                                                    {
                                                        view: 'richselect', // Rich select for Category
                                                        name: 'Category', // Input name
                                                        localId: 'categorie:combo', // Local ID for the category combo
                                                        label: "<span class='icon-category'></span>" + _('Categorías'), // Label for Category
                                                        labelPosition: 'top',
                                                        placeholder: _(
                                                            'Click para seleccionar ', // Placeholder text
                                                        ),
                                                        options: resp.data, // Options for the category
                                                        required: false, // Not required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Verificado'), // Label for Verified
                                                        name: 'IsVerified', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {},
                                                ],
                                            },
                                            {
                                                view: 'datatable', // Data table for Tags
                                                id: 'TagsAdds', // Table ID
                                                name: 'TagsAdds', // Table name
                                                height: 200, // Table height
                                                columns: [
                                                    {
                                                        id: 'ch1', // Column ID for checkbox
                                                        header: '', // Header for checkbox column
                                                        checkValue: 'on', // Value when checked
                                                        uncheckValue: 'off', // Value when unchecked
                                                        template: '{common.checkbox()}', // Checkbox template
                                                        width: 40, // Column width
                                                    },
                                                    {
                                                        id: 'title', // Column ID for title
                                                        header: [
                                                            {
                                                                text: 'Etiqueta', // Header for Tags
                                                            },
                                                            {
                                                                content: 'textFilter', // Filter content
                                                            },
                                                        ],
                                                        fillspace: true, // Fill space
                                                        sort: 'string', // Sorting type
                                                    },
                                                ],
                                                scrollX: false, // Disable horizontal scrolling
                                                navigation: true, // Enable navigation
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: _('Cancelar'), // Button text
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Close the window
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form', // Button type
                                                        value: _('Guardar'), // Button text
                                                        click: function ($e) {
                                                            // Click event for save button
                                                            if (
                                                                $$('addform').validate() // Validate form
                                                            ) {
                                                                var values = $$('addform').getValues(); // Get form values
                                                                let tagsSelected = $$('TagsAdds').serialize(); // Serialize tags
                                                                tagsSelected = tagsSelected.filter(
                                                                    (item) => item.ch1 === 'on', // Filter selected tags
                                                                );
                                                                tagsSelected = tagsSelected.map(
                                                                    (item) => item.id, // Map selected tag IDs
                                                                );
                                                                values.TagsAdd = tagsSelected.toString(); // Add selected tags to values
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Product/UpdateProductDetails', // API URL for updating product details
                                                                        values, // Request payload
                                                                        {
                                                                            error: function () {
                                                                                webix.message(
                                                                                    'Error! ', // Error message on failure
                                                                                );
                                                                            },
                                                                            success: function (text) {
                                                                                text = JSON.parse(
                                                                                    text, // Parse the response
                                                                                );
                                                                                if (text.HasError) {
                                                                                    webix.message(
                                                                                        'Error: ' + text.AlertMessage, // Error message on failure
                                                                                    );
                                                                                } else {
                                                                                    webix.message(
                                                                                        'Producto Agregado', // Success message
                                                                                    );
                                                                                    grid.clearAll(); // Clear the grid
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                this.getTopParentView().hide(); // Close the window
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Error title
                                                                    ),
                                                                    type: 'alert-error', // Error type
                                                                    text: _(
                                                                        'Completa los campos...', // Error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {},
                                            },
                                        },
                                    },
                                })
                                .show(); // Show the add window
                            webix.ajax().get(
                                devConfig.geturlApi() + 'Tag/GetTags', // API URL for fetching tags
                                '',
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        text = JSON.parse(text); // Parse the response
                                        let tagsDblList = $$('TagsAdds'); // Reference to the tags data table
                                        tagsDblList.parse(
                                            text.data.map((item) => {
                                                return {
                                                    id: item.Id, // Map tag ID
                                                    title: item.Name, // Map tag title
                                                };
                                            }),
                                        ); // Parse tags into the table
                                    },
                                },
                            );
                        },
                    },
                );
        });

        // Event listener for filtering products
        this.on(this.app, 'products:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&Column=' + by + '&Sort=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call event with item ID
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by player ID
            );
        });
    }
}

// FILE DOCUMENTED
